import { Element } from "@xmpp/xml"
import { DocumentLink, MessageDisplayType } from "@/reducers/messagesSlice"
import MessageParser from "./messageParser"

export default class DocumentLinkParser {
  static parse(stanza: Element, timestamp?: string): DocumentLink | undefined {
    const documentLinkNode = stanza.getChild("document-link")

    if (!documentLinkNode) return

    const cmrMessageId = documentLinkNode.attrs["cmr_message_id"]
    const deliveryOrderMessageId =
      documentLinkNode.attrs["delivery_order_message_id"]
    const cmrFileUrl = documentLinkNode.attrs["cmr_file_url"]
    const deliveryOrderFileUrl =
      documentLinkNode.attrs["delivery_order_file_url"]

    if (
      !cmrMessageId ||
      !deliveryOrderMessageId ||
      !cmrFileUrl ||
      !deliveryOrderFileUrl
    ) {
      console.warn(
        "DocumentLinkParser: skipping malformed document-link stanza, missing required attributes",
        {
          cmrMessageId,
          deliveryOrderMessageId,
          cmrFileUrl,
          deliveryOrderFileUrl,
        },
      )
      return undefined
    }

    return {
      id: MessageParser.id(stanza, false),
      to: stanza.attrs.to,
      from: stanza.attrs.from,
      cmrMessageId,
      deliveryOrderMessageId,
      cmrFileUrl,
      cmrFileName: documentLinkNode.attrs["cmr_file_name"],
      deliveryOrderFileUrl,
      deliveryOrderFileName: documentLinkNode.attrs["delivery_order_file_name"],
      timestamp: timestamp || new Date().toISOString(),
      displayType: MessageDisplayType.DocumentLink,
      type: stanza.attrs.type,
    }
  }
}
